import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class IpoBankMasterUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult() {
        return await this.Repo.getIpoBankMaster();
    }
}
export default IpoBankMasterUseCase;
